/*
* <license header>
*/

import React, { useState } from 'react'
import { Button, Flex, Text, TextArea, View, Well } from '@adobe/react-spectrum'
import Send from '@spectrum-icons/workflow/Send'

export const AppAssistant = ({ embedded }) => {
  const [message, setMessage] = useState('')

  const handleSend = () => {
    if (message.trim()) {
      console.log('Send:', message.trim())
      setMessage('')
    }
  }

  return (
    <Well
      marginTop={embedded ? undefined : 'size-300'}
      UNSAFE_style={{
        height: '100%',
        minHeight: embedded ? 200 : 320,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        ...(embedded && { border: 'none', padding: '0.5rem' })
      }}
    >
      <Flex direction="column" flex={1} minHeight={0} UNSAFE_style={{ overflow: 'hidden' }}>
        <View flex={1} UNSAFE_style={{ overflow: 'auto' }}>
          <Text UNSAFE_style={{ fontSize: embedded ? '1rem' : '1.5rem', fontWeight: 700, marginBottom: embedded ? '0.5rem' : '1rem', display: 'block' }}>
            Hi, I&apos;m the App Builder Assistant
          </Text>
          <Flex alignItems="start" gap={embedded ? 'size-100' : 'size-200'}>
            <div
              style={{
                width: embedded ? 40 : 64,
                height: embedded ? 40 : 64,
                borderRadius: '50%',
                backgroundColor: 'var(--card-accent)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: embedded ? '1.25rem' : '2rem',
                flexShrink: 0
              }}
            >
              🤖
            </div>
            <Text
              UNSAFE_style={{
                color: 'var(--gray-600)',
                fontSize: embedded ? '0.75rem' : '0.9375rem',
                lineHeight: 1.5,
                flex: 1
              }}
            >
              Tell me what&apos;s on your mind. I can help with App Builder development, deployment, extensions, and integration with Adobe Experience Cloud services.
            </Text>
          </Flex>
        </View>

        <View
          UNSAFE_style={{
            flexShrink: 0,
            marginTop: 'auto',
            border: '1px solid var(--card-border)',
            borderRadius: embedded ? '6px' : '8px',
            padding: embedded ? '0.5rem' : '1rem',
            backgroundColor: 'var(--white)'
          }}
        >
          <Flex gap="size-100" alignItems="end">
            <View flex={1} minWidth={0}>
              <TextArea
                aria-label="Message"
                placeholder={embedded ? 'Ask anything...' : 'Ask the App Builder Assistant anything. Describe your need with as much detail as possible for better results.'}
                value={message}
                onChange={setMessage}
                width="100%"
                minHeight={embedded ? 'size-400' : 'size-600'}
              />
            </View>
            <Button variant="accent" onPress={handleSend}>
              <Send size="S" />
              <span style={{ marginLeft: '0.5rem' }}>Send</span>
            </Button>
          </Flex>
        </View>
      </Flex>
    </Well>
  )
}
